import { render, staticRenderFns } from "./UserWallet.vue?vue&type=template&id=0d474a77&"
import script from "./UserWallet.vue?vue&type=script&lang=js&"
export * from "./UserWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports